export const defaultErrorMessage =
  "An unexpected error occurred, please try again later. If the issue persists, contact Support.";
